import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { CATEGORIES } from "@/lib/categories";

export default function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
      <Seo title="Pagina non trovata" description="La pagina che cerchi non esiste o è stata spostata." noindex />
      <p className="font-meta text-[11px] uppercase tracking-[0.24em] text-gold">Errore 404</p>
      <h1 className="mt-4 font-editorial font-extrabold text-4xl sm:text-5xl tracking-tight text-stone-900">
        Questa pagina <span className="mark-hl">non esiste</span>
      </h1>
      <p className="mt-5 text-stone-600">
        Il link potrebbe essere vecchio o scritto male. Riparti dalla home o scegli una categoria.
      </p>
      <Link to="/" data-testid="notfound-home-link"
        className="inline-block mt-8 px-6 py-3 rounded-full text-sm font-bold bg-stone-900 text-white sticker hover:-translate-y-0.5 transition-transform">
        Torna alla home
      </Link>
      <div className="mt-10 flex flex-wrap justify-center gap-2">
        {CATEGORIES.map((c) => (
          <Link key={c.slug} to={`/categoria/${c.slug}`} style={{ "--cat": c.hex }} className="nav-pill nav-pill-cat">
            <span className="dot" />{c.short}
          </Link>
        ))}
      </div>
    </div>
  );
}
